import { useState } from "react";
import { SmoothScroll } from "../components/site/SmoothScroll";
import { Nav } from "../components/site/Nav";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { HowItWorks } from "../components/site/HowItWorks";
import { Occasions } from "../components/site/Occasions";
import { Packages } from "../components/site/Packages";
import { Crew } from "../components/site/Crew";
import { BookingForm } from "../components/site/BookingForm";
import { Faq } from "../components/site/Faq";
import { Footer } from "../components/site/Footer";
import { ChatWidget } from "../components/site/ChatWidget";
import { PACKAGES } from "../content";

export default function Home() {
  const [pkg, setPkg] = useState(PACKAGES[1].name);
  const [occasion, setOccasion] = useState("Birthday");
  return (
    <main data-testid="home-page">
      <SmoothScroll />
      <Nav />
      <Hero />
      <Marquee />
      <HowItWorks />
      <Occasions onPick={setOccasion} />
      <Packages onPick={setPkg} />
      <Crew />
      <BookingForm pkg={pkg} setPkg={setPkg} occasion={occasion} setOccasion={setOccasion} />
      <Faq />
      <Footer />
      <ChatWidget />
    </main>
  );
}
